// The Halo "devices" illustration the mobile app shows above its sign-in form
// (app/src/screens/Auth/SignIn.js): the halo wordmark over a boiler, a PRT dial and
// a phone. Geometry and colours are COPIED VERBATIM from the react-native-svg
// original in app/src/components/common/Icons.js (HaloLoginDevices), so the web
// sign-in shows the real artwork rather than an approximation; attribute names are
// the React DOM camelCase spellings of the same SVG attributes. The hard-coded
// colours are the brand green, page charcoal and off-white — the same values as
// the --green-500 / --grey-950 / --grey-50 tokens.
//
// Like icons.jsx this is a deliberate MANUAL COPY: re-sync it if the app's changes.
//
// Decorative — the heading beside it names Halo — so it is hidden from assistive
// tech. The mask/path ids are namespaced so they cannot collide with any other
// inline SVG on the page. Size is set by the caller's CSS (.auth-brand svg); the
// width/height attributes only fix the aspect ratio.
export default function HaloLoginDevices() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 218 146.744"
      width="218"
      height="146.744"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <path id="halo-login-devices-a" d="M0 19L101.647 19 101.647 0 0 0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        {/* Boiler */}
        <g stroke="#95C11F" transform="translate(1 1) translate(122.872)">
          <path
            strokeLinejoin="round"
            strokeWidth="2"
            d="M0 3.354L76.475 0 93.128 5.593 93.128 132.778 76.475 144.744 0 136.089z"
          />
          <path strokeLinejoin="round" d="M76.475 0L76.475 144.744" />
          <path
            strokeLinejoin="round"
            d="M3.138 3.709L10.064 91.371 10.064 137.421"
          />
          <path
            strokeLinejoin="round"
            d="M66.971 0L55.37 96.562 55.37 142.612"
          />
          <path d="M76.475 95.708L55.37 98.708 10.064 95.708 0 91.758" />
        </g>
        {/* Phone showing the zone dial */}
        <g transform="translate(1 1) translate(0 55.228)">
          <path
            fill="#181818"
            stroke="#95C11F"
            strokeWidth="2"
            d="M0 0H112.381V76.532H0z"
          />
          <circle
            cx="71.323"
            cy="38.259"
            r="30.67"
            fill="#181818"
            stroke="#95C11F"
          />
          <path
            stroke="#95C11F"
            d="M59.44 53.615c2.234.87 5.167.59 7.086-.683 2.51-1.667 4.857-3.908 4.593-9.981a3.505 3.505 0 001.573-.396c.51 1.987.486 3.996.587 6.007.128 2.58 1.007 4.77 4.298 5.404 1.737.335 3.713.011 5.23-.9 3.72-2.233 5.886-5.36 6.378-9.005.38-2.809-1.622-6.154-4.16-7.415-2.7-1.341-5.814-2.252-10.942 1.014a3.505 3.505 0 00-1.127-1.166c1.465-1.435 3.216-2.419 4.908-3.51 2.17-1.402 3.627-3.259 2.53-6.425-.578-1.672-1.846-3.222-3.393-4.08-3.794-2.104-7.586-2.417-10.989-1.021-2.622 1.076-4.518 4.482-4.34 7.31.187 3.008.955 6.161 6.348 8.97a3.505 3.505 0 00-.206.424 3.505 3.505 0 00-.238 1.136c-1.976-.552-3.704-1.577-5.497-2.496-2.298-1.179-4.634-1.513-6.829 1.02-1.158 1.337-1.866 3.21-1.836 4.98.075 4.337 1.7 7.777 4.61 10.026.42.325.9.587 1.415.787zM70.086 41.95a2.689 2.689 0 111.974-5.002 2.689 2.689 0 01-1.974 5.002h0z"
          />
          <path fill="#95C11F" d="M6.833 76.98H10.389V81.457H6.833z" />
          <path fill="#95C11F" d="M101.992 76.98H105.548V81.457H101.992z" />
          <path stroke="#95C11F" d="M0 0L29.22 0 29.22 76.532 0 76.532z" />
        </g>
        {/* PRT dial */}
        <g transform="translate(1 1) translate(96.496 66.718)">
          <circle
            cx="26.375"
            cy="26.375"
            r="26.375"
            fill="#181818"
            stroke="#95C11F"
            strokeWidth="2"
          />
          <circle cx="26.375" cy="42.281" r="7.131" stroke="#95C11F" />
          <rect
            width="5.007"
            height="1.113"
            x="37.172"
            y="42.056"
            fill="#95C11F"
            rx="0.556"
          />
          <rect
            width="5.007"
            height="1.113"
            x="10.571"
            y="42.056"
            fill="#95C11F"
            rx="0.556"
          />
        </g>
        {/* "halo" wordmark */}
        <g transform="translate(1 1) translate(5.177 17.965)">
          <path
            fill="#FAFAFA"
            d="M71.565 18.715h-4.07c-4.29 0-7.78-3.495-7.78-7.79V.302h.543v10.621c0 3.997 3.246 7.249 7.237 7.249h4.07v.542z"
          />
          <path fill="#FAFAFA" d="M0 8.251L0.548 8.251 0.548 0.308 0 0.308z" />
          <path
            fill="#FAFAFA"
            d="M0 18.71h.542v-5.285a3.575 3.575 0 013.57-3.573l5.49-.002a4.118 4.118 0 004.11-4.116V.303h-.542v5.43a3.576 3.576 0 01-3.569 3.575l-5.49.001a4.118 4.118 0 00-4.11 4.116v5.286z"
          />
          <mask id="halo-login-devices-b" fill="#fff">
            <use href="#halo-login-devices-a" />
          </mask>
          <path
            fill="#FAFAFA"
            mask="url(#halo-login-devices-b)"
            d="M13.17 18.713L13.712 18.713 13.712 10.986 13.17 10.986z"
          />
          <path
            fill="#FAFAFA"
            mask="url(#halo-login-devices-b)"
            d="M92.17.562c-4.928 0-8.936 4.014-8.936 8.948 0 4.933 4.008 8.948 8.935 8.948 4.928 0 8.936-4.015 8.936-8.948 0-4.934-4.008-8.948-8.936-8.948m0 18.438c-5.225 0-9.477-4.257-9.477-9.49 0-5.233 4.252-9.49 9.477-9.49 5.226 0 9.478 4.257 9.478 9.49 0 5.233-4.252 9.49-9.478 9.49M28.5 18.712L37.041.727l8.473 17.985h.598L37.406.23a.4.4 0 00-.363-.23h-.001a.4.4 0 00-.365.23L27.9 18.712h.6z"
          />
        </g>
      </g>
    </svg>
  );
}
